__webpack_require__.p = "/mapartcraft/";